import React, { Fragment } from 'react'
import Column from '../../../generic/Column'
import Columns from '../../../generic/Columns'
import { BoxCenter } from '../../../generic/Box'
import Title from '../../../generic/Title'
// import NFETypeFilter from './NFETypeFilter'
import NFSTable from './NFSTable'
import NFSModal from './NFSModal'
import RPSModal from './RPSModal'

const NFEList = props => {
  return (
    <Fragment>
      <Columns>
        <Column>
          <BoxCenter>
            <Title>Arquivos XML</Title>
            {/* <NFETypeFilter /> */}
            <NFSTable />
          </BoxCenter>
        </Column>
      </Columns>
      <NFSModal />
      <RPSModal />
    </Fragment>
  )
}

export default NFEList



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfs/NFSList.js